// extracted by mini-css-extract-plugin
export default {"overlay":"modals_overlay__EZ9Jf","container":"modals_container__adVxL","info":"modals_info__eYIYH","closeButton":"modals_closeButton__WMkkw","title":"modals_title__hkJbM"};